import { render, staticRenderFns } from "./UserEditionDialog.vue?vue&type=template&id=3b9e017a&scoped=true"
import script from "./UserEditionDialog.ts?vue&type=script&lang=ts&external"
export * from "./UserEditionDialog.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9e017a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b9e017a')) {
      api.createRecord('3b9e017a', component.options)
    } else {
      api.reload('3b9e017a', component.options)
    }
    module.hot.accept("./UserEditionDialog.vue?vue&type=template&id=3b9e017a&scoped=true", function () {
      api.rerender('3b9e017a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/UsersManager/components/dialogs/UserEditionDialog/UserEditionDialog.vue"
export default component.exports